import { useSingleton } from '@okee-uikit/react-hooks';
import { FileUpload } from '../lib/fileUpload';
export function useCreateFileUpload() {
  return useSingleton(function () {
    return new FileUpload();
  });
}